import { Row, Col } from "react-bootstrap";
import LaunchIcon from '@mui/icons-material/Launch';

const ExternalLinkDisclaimer = () => {
  return (
    <>
      <Row className="m-0 public-background">
        <Row>
          <Col sm={0} md={1} lg={1}></Col>
          <Col sm={12} md={10} lg={10} xl={8} className="text-start" >
            <h1 id="mainContent" className="public-title text-start mb-4 pb-4" >
              <span className="dark-blue-footer-title">External Link Disclaimer</span>
            </h1>
            <h2 className="public-title text-start mb-3"><span className="black">Related links outside of PSO Privacy Protection Center</span></h2>
            <p>This graphic notice (<LaunchIcon className=""></LaunchIcon>External Web Link) means that you are leaving the PSOPPC Web site. This external link provides additional information that is consistent with the intended purpose of PSOPPC. </p>
            <p>Linking to a non-federal site does not constitute an endorsement by PSOPPC or any of its employees of the sponsors or the information and products presented on the site. PSO Privacy Protection Center (PSOPPC) cannot attest to the accuracy of information provided by this link. You will be subject to the destination site's privacy policy when you follow the link.</p>
          </Col>
          <Col lg={1}></Col>
        </Row>
      </Row>
    </>
  )
};

export default ExternalLinkDisclaimer;